import { render, staticRenderFns } from "./WishlistDetail.vue?vue&type=template&id=6d43b441&"
import script from "./WishlistDetail.vue?vue&type=script&lang=js&"
export * from "./WishlistDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports